import { SECTION_CONFIGS } from '../../constants/sectionConfig.constants';
import type { Application } from '../../types/application.types';
import { CollapsibleSection } from '../shared/CollapsibleSection';
import { FormattedField } from '../shared/FormattedField';

interface ClientInfoStepProps {
  application: Application;
}

export function ClientInfoStep({ application }: ClientInfoStepProps) {
  const config = SECTION_CONFIGS.client;

  // Extraire les informations client
  const clientData = {
    customerName: application.customerName || `${application.firstName || ''} ${application.lastName || ''}`.trim(),
    customerEmail: application.customerEmail || application.email,
    customerPhone: application.customerPhone || application.phone,
  };

  // Extraire les informations entreprise (de toutes les sources)
  const companyData = {
    companyName: application.companyName || application.specificDetails?.companyName,
    companyEmail: application.companyEmail || application.specificDetails?.companyEmail,
    companyPhone: application.companyPhone || application.specificDetails?.companyPhone,
    companyWebsite: application.companyWebsite || application.specificDetails?.companyWebsite,
  };

  // Filtrer les champs vides
  const companyFields = Object.entries(companyData)
    .filter(([_, value]) => value)
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

  // Nombre de participants
  const participantCount = application.participantCount || application.specificDetails?.participantCount;

  return (
    <CollapsibleSection title={config.title} color={config.color} icon={config.icon} defaultOpen={config.defaultOpen}>
      <div className="space-y-6">
        {/* Informations Client */}
        <div>
          <h4 className="text-sm font-bold text-slate-700 uppercase tracking-wide mb-4">Contact Principal</h4>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
            {clientData.customerName && <FormattedField fieldKey="customerName" value={clientData.customerName} />}
            {clientData.customerEmail && <FormattedField fieldKey="customerEmail" value={clientData.customerEmail} />}
            {clientData.customerPhone && <FormattedField fieldKey="customerPhone" value={clientData.customerPhone} />}
          </div>
        </div>

        {/* Informations Entreprise */}
        {Object.keys(companyFields).length > 0 && (
          <div>
            <h4 className="text-sm font-bold text-slate-700 uppercase tracking-wide mb-4">Entreprise</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              {Object.entries(companyFields).map(([key, value]) => (
                <FormattedField key={key} fieldKey={key} value={value} />
              ))}
            </div>
          </div>
        )}

        {/* Nombre de Participants */}
        {participantCount && (
          <div>
            <h4 className="text-sm font-bold text-slate-700 uppercase tracking-wide mb-4">Réservation</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-4">
              <FormattedField fieldKey="participantCount" value={participantCount} />
            </div>
          </div>
        )}
      </div>
    </CollapsibleSection>
  );
}
